import type { InputHTMLAttributes } from 'react';
import React, { useMemo } from 'react';
import { styled, theme } from '@components-shared/src/stitches';

export const Slider = ({
  min = 1,
  max = 3,
  step = 0.1,
  value,
  ...props
}: {
  min?: number;
  max?: number;
  step?: number;
  value: number;
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange'];
}) => {
  const backgroundSize = useMemo(() => {
    return ((value - min) * 100) / (max - min) + '% 100%';
  }, [max, min, value]);

  return (
    <SliderInput
      type="range"
      role="slider"
      min={min}
      max={max}
      step={step}
      value={value}
      css={{ backgroundSize }}
      {...props}
    />
  );
};

const SliderInput = styled('input', {
  '-webkit-appearance': 'none',
  marginRight: '15px',
  width: '100%',
  height: '5px',
  background: theme.colors.gray200,
  borderRadius: '5px',
  backgroundImage: `linear-gradient(${theme.colors.blue400}, ${theme.colors.blue400})`,
  backgroundRepeat: 'no-repeat',

  '&::-webkit-slider-thumb': {
    '-webkit-appearance': 'none',
    height: '0.9em',
    width: '0.9em',
    borderRadius: '50%',
    background: theme.colors.white,
    cursor: 'ew-resize',
    boxShadow: '0 0 1px 0 #555',
    transition: 'background .3s ease-in-out',
  },

  '&:focus::-webkit-slider-thumb': {
    outline: `3px solid ${theme.colors.brandAccent100}`,
  },

  '&::-webkit-slider-runnable-track': {
    '-webkit-appearance': 'none',
    boxShadow: 'none',
    border: 'none',
    background: 'transparent',
  },
});
